module.exports = __webpack_public_path__ + "img/storeinfoimage.906993b7.png";